var map = {
	"./load_more_comments/controller.js": 88569,
	"./show_replies/controller.js": 4846,
	"src/decidim/comments/controllers/load_more_comments/controller.js": 88569,
	"src/decidim/comments/controllers/show_replies/controller.js": 4846
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 97795;